import config from 'rebass/config';

export default config;
